<div class="calendar-page">


<div class="calendar-container">


<!-- CALENDAR -->

<div class="calendar-section">


<div class="calendar-header">


<button (click)="previousMonth()">
‹
</button>


<h2>
{{monthName}} {{year}}
</h2>


<button (click)="nextMonth()">
›
</button>


</div>




<div class="legend">

<div>
<span class="normal-box"></span>
Available
</div>

<div>
<span class="wedding-box"></span>
Weddingly Booking
</div>


<div>
<span class="leave-box"></span>
Personal Leave
</div>


<div>
<span class="outside-box"></span>
Outside Booking
</div>


</div>





<div class="calendar-grid">


<div class="day-name"
*ngFor="let day of weekDays">

{{day}}

</div>



<div
  class="date-cell"
  *ngFor="let date of calendarDays"
  [class.empty]="date == null"
  [class.wedding]="date && getDateType(date)=='Weddingly Booking'"
  [class.leave]="date && getDateType(date)=='Personal Leave'"
  [class.outside]="date && getDateType(date)=='Outside Booking'"
  (click)="date && selectDate(date)"
>
  {{ date || '' }}
</div>



</div>


</div>







<!-- BLOCK CARDS -->


<div class="blocked-section">


<div class="blocked-header">

<h2>
Blocked Dates
</h2>


<button
(click)="openBlockForm()">

+ Block Date

</button>


</div>




<div class="blocked-list">
<div 
class="blocked-card"
*ngFor="let item of filteredBlockedDates">



<h3>

{{item.day}}

</h3>



<span
class="type"
[class.wedding]="item.type=='Weddingly Booking'"
[class.leave]="item.type=='Personal Leave'"
[class.outside]="item.type=='Outside Booking'">

{{item.type}}

</span>




<p *ngIf="item.details">

{{item.details}}

</p>



<p *ngIf="item.location">

📍 {{item.location}}

</p>



<div class="actions">


<button
(click)="viewDetails(item)">
View Details
</button>


<button
class="delete"
(click)="deleteBlockedDate(item._id)">
Delete
</button>


</div>



</div>

</div>

</div>


</div>









<!-- BLOCK DATE POPUP -->


<div class="overlay" *ngIf="showBlockForm">


<div class="block-modal">


<div class="modal-header">

<h2>
Block Date
</h2>


<button
(click)="closeBlockForm()">

✕

</button>


</div>






<form
[formGroup]="blockForm"
(ngSubmit)="saveBlockedDate()">


<!-- DATE -->

<label>
Blocked Date *
</label>


<input
type="date"
formControlName="date">



<div class="error"
*ngIf="
blockForm.get('date')?.touched &&
blockForm.get('date')?.invalid
">

Date is required

</div>







<!-- TYPE -->


<label>
Blocked For *
</label>


<select
formControlName="blocked_for"
(change)="changeBlockType()">


<option value="">
Select Type
</option>


<option value="Weddingly Booking">
Weddingly Booking
</option>


<option value="Personal Leave">
Personal Leave
</option>


<option value="Outside Booking">
Outside Booking
</option>


</select>


<div class="error"
*ngIf="
blockForm.get('blocked_for')?.touched &&
blockForm.get('blocked_for')?.invalid
">

Type is required

</div>










<!-- WEDDINGLY BOOKING -->


<div
*ngIf="blockForm.value.blocked_for === 'Weddingly Booking'"
class="extra-fields">


<h3>
Weddingly Booking Details
</h3>




<label>
Customer Name *
</label>


<input
placeholder="Customer Name"
formControlName="customer_name">


<div class="error"
*ngIf="
blockForm.get('customer_name')?.touched &&
blockForm.get('customer_name')?.invalid
">

Customer Name is required

</div>







<label>
Customer Phone *
</label>


<input
placeholder="Customer Phone"
formControlName="customer_phone">


<div class="error"
*ngIf="
blockForm.get('customer_phone')?.touched &&
blockForm.get('customer_phone')?.invalid
">

Customer Phone is required

</div>







<label>
Function Name *
</label>


<input
placeholder="Function Name"
formControlName="function_name">


<div class="error"
*ngIf="
blockForm.get('function_name')?.touched &&
blockForm.get('function_name')?.invalid
">

Function Name is required

</div>







<label>
Location *
</label>


<input
placeholder="Location"
formControlName="location">


<div class="error"
*ngIf="
blockForm.get('location')?.touched &&
blockForm.get('location')?.invalid
">

Location is required

</div>







<label>
Function Details *
</label>


<textarea

placeholder="Function Details"

formControlName="details">

</textarea>



<div class="error"
*ngIf="
blockForm.get('details')?.touched &&
blockForm.get('details')?.invalid
">

Function Details are required

</div>



</div>










<!-- PERSONAL LEAVE / OUTSIDE BOOKING -->


<div
*ngIf="
blockForm.value.blocked_for === 'Personal Leave'
||
blockForm.value.blocked_for === 'Outside Booking'
"
class="extra-fields">





<label>
Reason *
</label>


<input
placeholder="Reason"
formControlName="reason">



<div class="error"
*ngIf="
blockForm.get('reason')?.touched &&
blockForm.get('reason')?.invalid
">

Reason is required

</div>







<label>
Location *
</label>


<input
placeholder="Location"
formControlName="location">



<div class="error"
*ngIf="
blockForm.get('location')?.touched &&
blockForm.get('location')?.invalid
">

Location is required

</div>





</div>








<div class="modal-actions">


<button
type="button"
class="cancel"
(click)="closeBlockForm()">

Cancel

</button>



<button
type="submit"
class="save-btn">

Save Date

</button>


</div>





</form>



</div>


</div>
<!-- VIEW DETAILS POPUP -->

<div class="overlay" *ngIf="showDetails">


<div class="block-modal">


<div class="modal-header">

<h2>
Blocked Date Details
</h2>


<button
(click)="closeDetails()">

✕

</button>

</div>



<div *ngIf="selectedDate">


<p>
<b>Date:</b>
{{selectedDate.day}}
</p>


<p>
<b>Type:</b>
{{selectedDate.blocked_for}}
</p>



<p *ngIf="selectedDate.customer_name">

<b>Customer:</b>
{{selectedDate.customer_name}}

</p>



<p *ngIf="selectedDate.customer_phone">

<b>Phone:</b>
{{selectedDate.customer_phone}}

</p>



<p *ngIf="selectedDate.function_name">

<b>Function:</b>
{{selectedDate.function_name}}

</p>



<p *ngIf="selectedDate.location">

<b>Location:</b>
{{selectedDate.location}}

</p>



<p *ngIf="selectedDate.details">

<b>Details:</b>
{{selectedDate.details}}

</p>



<p *ngIf="selectedDate.reason">

<b>Reason:</b>
{{selectedDate.reason}}

</p>


</div>


</div>


</div>